import React, { Component } from 'react';
import Header from '../../components/Header';


class Contact extends Component {
  render() {
    return (
      <div>
				<Header
          handleLogout={this.props.handleLogoutClick}
					primaryText="NEW CAMPAIGN"
					title="TEXT" />
      </div>
    );
  }
}

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/containers/Contact/index.js
 **/